import { defineComponent } from 'vue'
import { store } from '#models/store'
import SignaturePadVue from '../SignaturePad/SignaturePad.vue'

export default defineComponent({
  components: {
    SignaturePad: SignaturePadVue
  },
  data() {
    const form = store.cancellationPolicyForm

    return {
      form
    }
  }
})
